import * as React from "react";
import {observer} from "mobx-react";
import {withAppStores} from "../../../../../AppStores";
import {SettingTableTab} from "../abstract/SettingTableTab";
import {TabChild} from "../../../../widgets/tab/TabChild";
import {TabView} from "../../../../widgets/tab/TabView";
import type {Type} from "../../../../../data/models/Type";
import type {XyiconFeature} from "../../../../../generated/api/base";
import type {AppState} from "../../../../../data/state/AppState";
import {featureTitles} from "../../../../../data/state/AppStateConstants";
import {DateFormatter} from "../../../../../utils/format/DateFormatter";
import type {IHeader} from "../../../../widgets/table/SimpleTable";
import {CreateTypePanel} from "./CreateTypePanel";
import {TypeDetailsContent} from "./TypeDetailsContent";

interface ITypeSettingsProps {
	readonly feature: XyiconFeature;
	readonly typesFeature: XyiconFeature;
	readonly appState?: AppState;
}

interface ITypeSettingsState {
	columns: IHeader[];
}

@withAppStores("appState")
@observer
export class TypeSettings extends React.Component<ITypeSettingsProps, ITypeSettingsState> {
	private _appState: AppState;

	private readonly _columns = [
		{
			id: "name",
			title: "Name",
		},
		{
			id: "system",
			title: "System",
		},
		{
			id: "lastModifiedAt",
			title: "Last updated",
		},
	];

	constructor(props: ITypeSettingsProps) {
		super(props);
		this._appState = props.appState;
	}

	private getFields = (type: Type) => {
		return this._columns.map((field) => {
			// TODO
			const id = field.id;

			switch (id) {
				case "system":
					return this._appState.actions.getBooleanFieldTitle(type.isSystem);
				case "lastModifiedAt":
					return DateFormatter.format(type.lastModifiedAt);
				default:
					return type[id as "name"];
			}
		});
	};

	public override render() {
		const {feature, typesFeature} = this.props;

		return (
			<SettingTableTab
				headers={this._columns}
				getFields={this.getFields}
				feature={feature}
				typesFeature={typesFeature}
				kind="types"
				right={(selected) => (
					<TabView
						className="SidePanel"
						selectedTabId="details"
					>
						<TabChild
							id="details"
							icon="details"
							title="Details"
							label="Details"
						>
							<TypeDetailsContent
								selected={selected}
								fieldsFeature={feature}
							/>
						</TabChild>
					</TabView>
				)}
				create={(onCancel, onCreated) => (
					<CreateTypePanel
						feature={typesFeature}
						moduleFeature={feature}
						onCancel={onCancel}
						onCreated={onCreated}
					/>
				)}
				emptyListText={`There are no ${featureTitles[feature]} Types to list.`}
			/>
		);
	}
}
